// LoginPopup.js
import React, { useState } from "react";
import "./LoginPopup.css";
import logo from "./justseologo.png";
import googlelogin from './popupGoogle.png'

const LoginPopup = ({ onClose }) => {
  const [isSignUp, setIsSignUp] = useState(false);
  const [formData, setFormData] = useState({
    username: "",
    password: "",
    email: "",
    confirmPassword: ""
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle login/signup logic here
    console.log(formData);
  };

  return (
    <div className="js-login-popup-overlay" onClick={onClose}>
      <div className="js-login-popup-container" onClick={(e) => e.stopPropagation()}>
        <div className="js-login-popup-content">
          <div className="js-login-popup-left">
            <img src={logo} alt="Just SEO Logo" className="js-login-popup-logo" />
            <h2 className="js-login-popup-title">{isSignUp ? "Click. Connect. Climb the Rankings." : "Good to See You — Let’s Make Google Love You"}</h2>
            <p className="js-login-popup-subtitle">
              {isSignUp
                ? "Join us to get started with our services"
                : "Sign in to access your client portal"}
            </p>
          </div>
          <div className="js-login-popup-right">
            <form className="js-auth-form" onSubmit={handleSubmit}>
              {isSignUp && (
                <div className="js-form-group">
                  <label htmlFor="js-email" className="js-form-label">Email</label>
                  <input
                    type="email"
                    id="js-email"
                    name="email"
                    className="js-form-input"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>
              )}
              <div className="js-form-group">
                <label htmlFor="js-username" className="js-form-label">Username</label>
                <input
                  type="text"
                  id="js-username"
                  name="username"
                  className="js-form-input"
                  value={formData.username}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="js-form-group">
                <label htmlFor="js-password" className="js-form-label">Password</label>
                <input
                  type="password"
                  id="js-password"
                  name="password"
                  className="js-form-input"
                  value={formData.password}
                  onChange={handleChange}
                  required
                />
              </div>
              {isSignUp && (
                <div className="js-form-group">
                  <label htmlFor="js-confirm-password" className="js-form-label">Confirm Password</label>
                  <input
                    type="password"
                    id="js-confirm-password"
                    name="confirmPassword"
                    className="js-form-input"
                    value={formData.confirmPassword}
                    onChange={handleChange}
                    required
                  />
                </div>
              )}
              {!isSignUp && (
                <div className="js-forgot-password">
                  <a href="#forgot" className="js-forgot-password-link">Forgot Password?</a>
                </div>
              )}
              <button type="submit" className="js-login-button">
                {isSignUp ? "Sign Up" : "Sign In"}
              </button>
              <div className="js-social-login">
                <p className="js-social-login-text">Or {isSignUp ? "sign up" : "sign in"} with</p>
                <button type="button" className="js-google-login">
                  <img
                    src={googlelogin}
                    alt="Google logo"
                    className="js-google-logo"
                  />
                  Google
                </button>
              </div>
              <div className="js-toggle-form">
                {isSignUp ? "Already have an account? " : "Don't have an account? "}
                <button
                  type="button"
                  onClick={() => setIsSignUp(!isSignUp)}
                  className="js-toggle-form-button"
                >
                  {isSignUp ? "Sign In" : "Sign Up"}
                </button>
              </div>
            </form>
          </div>
          <button className="js-close-popup" onClick={onClose}>
            &times;
          </button>
        </div>
      </div>
    </div>
  );
};

export default LoginPopup;